export default __webpack_public_path__ + "static/media/payroll-header.77f5f9a8.svg";